module.exports = __webpack_public_path__ + "static/CAPEB-57b2d08b79e8b8b928374f76a26d6b97.jpg";